import { Service, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Toast } from '../models/toast.model';

@Service()
export class NotifierService {
    private _toasts: Toast[] = [];

    private _toastWatch = new BehaviorSubject<Toast[]>([]);
    public toastList(): Observable<Toast[]> {
        return this._toastWatch;
    }

    public info(message: string, title: string = 'Information'): void {
        this._toasts.push({ msg: message, className: 'bg-info text-light', delay: 5000 });
        this._toastWatch.next(this._toasts);
    }

    public success(message: string, title: string = 'Success'): void {
        this._toasts.push({ msg: message, className: 'bg-success text-light', delay: 5000 });
        this._toastWatch.next(this._toasts);
    }

    public error(message: string, title: string = 'Error'): void {
        this._toasts.push({ msg: message, className: 'bg-danger text-light', delay: 0 });
        this._toastWatch.next(this._toasts);
    }

    remove(toast: Toast) {
        this._toasts = this._toasts.filter((t) => t !== toast);
        this._toastWatch.next(this._toasts);
    }

    clear() {
        this._toasts = [];
        this._toastWatch.next(this._toasts);
    }
}

